import { render, staticRenderFns } from "./EditProductDetails.vue?vue&type=template&id=0a7e5598&scoped=true&"
import script from "./EditProductDetails.vue?vue&type=script&lang=js&"
export * from "./EditProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditProductDetails.vue?vue&type=style&index=0&id=0a7e5598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7e5598",
  null
  
)

export default component.exports